import { CommonState } from "@idw-types/state";
import { CommonActionTypes, CommonActions } from "../actions/common-actions";

export const initialCommonState: CommonState = {
	asi: null,
	token: null,
	country: null,
	configUrl: null,
	contextPath: null,
	isVerifying: false,
	isUpdatingAttributeStatus: false,
	verificationError: null,
	verificationMessage: null,
	customHeaderHTML: null,
	customFooterHTML: null,
	isCustomCssLoaded: false,
	redirectUrl: null,
	useRollbar: false,
	availableCountries: null,
	shouldRedirect: null,
	showBokuConsentFooter: null,
	attributeReadOnlyStatusMap: null,
	shouldUpdateSubmitButton: true,
	forceShowAppVersion: false
};

export const commonReducer = (
	state: CommonState = initialCommonState,
	action: CommonActions
): CommonState => {
	switch (action.type) {
		case CommonActionTypes.SET_REDIRECT_URL:
			return {
				...state,
				redirectUrl: action.payload.redirectUrl
			};
		case CommonActionTypes.SET_CUSTOM_HEADER_HTML:
			return {
				...state,
				customHeaderHTML: action.payload.html
			};
		case CommonActionTypes.SET_CUSTOM_FOOTER_HTML:
			return {
				...state,
				customFooterHTML: action.payload.html
			};
		case CommonActionTypes.SUBMIT_VERIFICATION_DATA:
			return { ...state, isVerifying: true, verificationError: null };
		case CommonActionTypes.SUBMIT_VERIFICATION_DATA_FAILED:
			return { ...state, isVerifying: false, verificationError: action.payload.message };
		case CommonActionTypes.SET_VERIFICATION_MESSAGE:
			return { ...state, verificationMessage: action.payload.message };
		case CommonActionTypes.PROCESS_VERIFICATION_RESPONSE:
			return { ...state, isUpdatingAttributeStatus: true };
		case CommonActionTypes.PROCESS_VERIFICATION_RESPONSE_COMPLETE:
			return { ...state, isUpdatingAttributeStatus: false };
		case CommonActionTypes.SET_CUSTOM_CSS_LOADED:
			return { ...state, isCustomCssLoaded: action.payload.isCustomCssLoaded };
		case CommonActionTypes.SET_ROLLBAR_ENABLED:
			return { ...state, useRollbar: action.payload.enabled };
		case CommonActionTypes.SET_SHOULD_REDIRECT:
			return { ...state, shouldRedirect: action.payload.shouldRedirect };
		case CommonActionTypes.SET_SHOULD_UPDATE_SUBMIT_BUTTON:
			return { ...state, shouldUpdateSubmitButton: action.payload.shouldUpdate };
		case CommonActionTypes.SET_FORCE_SHOW_APP_VERSION:
			return { ...state, forceShowAppVersion: action.payload.forceShowAppVersion };
		default:
			return state;
	}
};